// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__a8fFS","range":"MonthRangeSwitch_range__3hNm5","disabled":"MonthRangeSwitch_disabled__3owED"};